import script from "./PersonnelMovementChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonnelMovementChart.vue?vue&type=script&setup=true&lang=js"

import "./PersonnelMovementChart.vue?vue&type=style&index=0&id=40629baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40629baa"]])

export default __exports__